define('controllers/mysetting/mod-userinfocorp.ctrl',['app', 'mainCons', 'viewer'], function (app, mainCons, imgViewer) {
    app.controller('ModUserInfoCorp', ['$q', '$scope', '$state', '$stateParams', '$location', '$filter', 'auiUpload', 'auiDialog',
        'UserInfo', 'regionService', 'modUserInfoService', 'formValidateService',
        'OpenUp', 'auiAgreementHelper', 'modBussService', '$rootScope', 'userAuth',
        'cloudAcademyService', 'langService', 'commonUtils',
        function ($q, $scope, $state, $stateParams, $location, $filter, auiUpload, auiDialog,
                  UserInfo, regionService, modUserInfoService, formValidateService,
                  OpenUp, auiAgreementHelper, modBussService, $rootScope, userAuth,
                  cloudAcademyService, langService, commonUtils) {
            $state.go('mysetting.modUserInfoCorpHm');
            return;
            var Model = $scope.Model = {
                errorPhone: [],
                contactMobilePhoneVerification:systemParaConf.contactMobilePhoneVerification,
            };
            var userInfo = Model.userInfo = {
                'contactorImg1': '',
                'contactorImg2': '',
                'contactorImg3': '',
                'corpNameChange': '',
                'contactorImg11': '',
                'contactorImg10': '',
                'corpLicense': '',
                'tax': '',
                'corpCode': '',
                'corpEntityPicFile': '',
                'corpEntityPicFile1': '',
            };
            Model.submbIsGray = true;
            Model.hwCloudIdShow = false
            Model.doSubmit = function () {
            };
            Model.isTipShow = false;
            Model.firstmessTip = '';
            Model.isShowNameChangeDiv = false;
            Model.inputIsDisable = true;
            Model.isRadioSelected = false;
            Model.isShowChaicon = true;
            Model.isAudting = false;
            Model.isRadioDisable = false;
            Model.isShowphoneValid = false;
            Model.verifiedEmailSuccess = false;
            Model.verifiedPhoneSuccess = false;
            Model.isCorpattionRz = false;
            Model.showThree2OneBox = false;
            Model.userInfo.oldCorpLicense = '';
            Model.userInfo.oldTax = '';
            Model.userInfo.oldCorpCode = '';
            Model.userInfo.country = {
                'key': '',
                'value': ''
            };
            Model.agreement = {}
            Model.signedAgreeList = [];
            Model.shareAgreementList = [];
            Model.showAgreeList = [];

            var frameAgreements = mainCons.agreementConstants.frameAgreements;
            Model.channelsList = systemParaConf.authentication.channels;
            $scope.photoUrl = sysParamCfg.photoUrl;
            Model.channelOtherCheck = false;
            Model.channelsChecked = [];
            Model.remark4userinfo = '';
            var quetionnareLable = $stateParams.quetionnareLable;

            //初始化获取是否三证合一
            var isThree;
            Model.isEmailNeedCode = false;
            //是否简化实名标识
            Model.isShowSimplifyApproval = false;

            Model.isShowNormalApproval = false;

            //三证合一复选框是否选中
            Model.isThree2One = false;

            //是否展示三证合一图片
            Model.isShowNormalApproval3to1 = false;


            Model.isShowEmailValid = false;

            Model.isShowQuetionnare = false;

            Model.isShowCloudCademy = false;
            Model.notAltModDevName = false;

            $scope.checkIsSameWithUPEmail = UserInfo.checkIsSameWithUPEmail;
            $scope.checkIsSameWithUPPhone = UserInfo.checkIsSameWithUPPhone;
            Model.mainUserID = AUI.HDGWCall.getUserInfoValue('teamid');
            // 显示语种集合
            Model.notifyMsgLangList = sysParamCfg.displaylangCountries;
            // 是否维护通知消息语种
            Model.showMsgLang = sysParamCfg.displayMsgLangFlag;
            var oldUserInfo = {};
            var userInfoToString = '';
            Model.isCorpFaceRz = false; // 是否是人脸识别认证

            // 计录页面修改项的计数
            var changeNum = 1;

            Model.greenSubmit = greenSubmit;
            Model.graySubmit = graySubmit;

            //定义各输入框对应的素数（控制提交按钮是否展示）
            var primes = modUserInfoService.returnPrimes();

            //SRM PRM错误信息展示
            Model.isShowPrmSrmTip = false;
            Model.PrmSrmMsgTip = "";
            $scope.changeRealName = changeRealName;
            Model.upload2openUP = upload2openUP;
            Model.hmChannel = ''
            Model.myParams = userAuth.getParam4Url()
            if (Model.myParams && Model.myParams.length > 0 && Model.myParams[0] === 'channel') {
                Model.hmChannel = Model.myParams[1]
            }
            if ($state.$current.name == "mysetting.modUserInfoCorp") {
                $rootScope.checkState($state).then(function () {
                    if (!$scope.isHarmony) {
                        auiAgreementHelper.getAllAgreementStatus(sysParamCfg.shareAgreements.agrTypes).then(function (querySignInfoList) {
                            angular.forEach(querySignInfoList.signInfoList, function (signInfo) {
                                if (signInfo.signStatus != 3) {
                                    Model.shareAgreement = signInfo;
                                    Model.shareAgreementList.push(Model.shareAgreement);
                                }
                            });
                            angular.forEach(Model.shareAgreementList, function (data) {
                                angular.forEach(sysParamCfg.shareAgreement, function (item) {
                                    if (data.agrType === item.agrType) {
                                        Model.agreement = item;
                                        Model.showAgreeList.push(Model.agreement)
                                    }
                                })
                            });
                            if (Model.showAgreeList && Model.showAgreeList.length > 0) {
                                Model.isShowShareAgreement = true;
                            } else {
                                Model.isShowShareAgreement = false;
                            }
                            init();
                        }).catch(function () {
                            init();
                        });
                    } else {
                        init();
                    }
                });
            }

            function setIsShowCloudCademy() {
                cloudAcademyService.queryLecturerInfo().then(function (resp) {
                    if (resp.resultCode == 0 && resp.lectrueInfo && AUI.BaseJSUtil.contains([1, 2, 4, 5, 6], resp.lectrueInfo.auditState)) {
                        Model.isShowCloudCademy = true;
                    }
                });
            }

            Model.devName4InnerKeyup = function () {
                checkPrime("devName4Inner", "devName4InnerPrime");
            };
            Model.devNameEn4InnerKeyup = function () {
                checkPrime("devNameEn4Inner", "devNameEn4InnerPrime");
            };
            //校验手机号格式是否正确
            $scope.validatePhone = (function () {
                return modUserInfoService.validatePhone();
            })();

            $scope.checkErrorPhone = function () {
                return AUI.BaseJSUtil.contains(Model.errorPhone, Model.userInfo.contactPhone);
            }

            function init() {
                if (quetionnareLable) {
                    scrollDown();
                }
                Model.downChangeNameTemplate = systemParaConf.ChangeEnterpriseNameTemp.ChangeEnterpriseNameTempUrl;
                Model.countrys = [{'key': '中国', 'value': '中国'}];
                // 获取省份，现在统一到idata中，通过opendeveloper接口封装
                regionService.setProvince(function (data) {
                    Model.provinces = data;

                    modUserInfoService.isSupportDevName().then(function (data) {
                        Model.isSupportDevName = data;
                        if (Model.isSupportDevName) {
                            //获取cp信息展示
                            getExtAttr('altDevName').then(function (flag) {
                                if (flag == 0 || flag == 'null') {
                                    Model.notAltModDevName = true;
                                }
                            });
                            getExtAttr('devNameStatus').then(function (flag) {
                                if (flag == 0) {
                                    Model.isShowInvalid = true;
                                }

                            });
                        }
                    });
                    UserInfo.userAcctInfoList().then(function (userInfo) {
                        setUserInfo(userInfo);
                    });
                    if (!$scope.isHarmony) {
                        setIsShowCloudCademy();
                    }
                    Model.userInfo.country = Model.countrys[0];
                });

                UserInfo.getUserRouteInfo().then(function (data) {
                    // 有开发者角色，才显示新手指引
                    if (data.roleList && angular.isArray(data.roleList)) {
                        var roleList = data.roleList;
                        //改成取消显示非联盟协议
                        if (AUI.BaseJSUtil.contains(roleList, sysParamCfg.roleType.SM)) {
                            Model.signedAgreeList.push(frameAgreements[0]);
                        }
                        if (AUI.BaseJSUtil.contains(roleList, sysParamCfg.roleType.HWCloudRole)) {
                            Model.signedAgreeList.push(frameAgreements[5]);
                        }
                    }
                });
            }

            //如果从关联关系问卷调查页面跳转过来，需要置底
            function scrollDown() {
                $(".container-fixed").animate({scrollTop: 99999}, 'slow');
            }


            //跳转更名页面
            function changeRealName() {
                UserInfo.updateCache(function () {
                    $state.go("nameChangeCorp", {reload: true});
                });
            }


            Model.downLoadAgreement = function () {
                auiAgreementHelper.viewAndDownloadAgreements(mainCons.agreementConstants.frameAgreementTypes);
            };

            //选择或或知渠道
            Model.selectChannel = function (value) {
                modUserInfoService.selectChannelType(value, Model, primes, differValue, sameValue, oldUserInfo);
            }

            Model.uploadContactorImg1 = function (files, options) {
                upload2openUP(files, options, primes.contactorImg1Prime, 'contactorImg1', 'contactorImg1WH');
            };

            Model.uploadContactorImg2 = function (files, options) {
                upload2openUP(files, options, primes.contactorImg2Prime, 'contactorImg2', 'contactorImg2WH');
            };

            Model.uploadContactorImg3 = function (files, options) {
                upload2openUP(files, options, primes.contactorImg3Prime, 'contactorImg3', 'contactorImg3WH');
            };

            Model.uploadContactorImg10 = function (files, options) {
                upload2openUP(files, options, primes.contactorImg10Prime, 'contactorImg10', 'contactorImg10WH');
            };

            Model.uploadContactorImg11 = function (files, options) {
                upload2openUP(files, options, primes.contactorImg11Prime, 'contactorImg11', 'contactorImg11WH');
            };

            Model.uploadCorpNameChange = function (files, options) {
                upload2openUP(files, options, primes.corpNameChangePrime, 'corpNameChange', 'corpNameChangeWH');
            };

            Model.uploadCorpLicense = function (files, options) {
                upload2openUP(files, options, primes.corpLicensePrime, 'corpLicense', 'corpLicenseWH');
            };

            Model.uploadTax = function (files, options) {
                upload2openUP(files, options, primes.taxPrime, 'tax', 'taxWH');
            };

            Model.uploadCorpEntityPicFile = function (files, options) {
                upload2openUP(files, options, primes.corpEntityPicFilePrime, 'corpEntityPicFile', 'corpEntityPicFileWH');
            };

            Model.uploadCorpCode = function (files, options) {
                upload2openUP(files, options, primes.corpCodePrime, 'corpCode', 'corpCodeWH');
            };

            Model.uploadCorpEntityPicFile1 = function (files, options) {
                upload2openUP(files, options, primes.corpEntityPicFile1Prime, 'corpEntityPicFile1', 'corpEntityPicFile1WH');
            };

            Model.uploadAppealAttach = function (files, options) {
                upload2openUP(files, options, primes.appealAttach, 'appealAttach', 'appealAttach');
            };
            Model.reCploadCorpCode = function () {
                auiDialog.warn("如您需要更新企业营业执照，请勾选“三证合一”复选框后，在营业执照上传处上传证件。")
            };


            function upload2openUP(files, options, prime, img, imgWH) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        differValue(prime);
                        Model.userInfo[img] = fileUrl;
                        AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                            $scope.$apply(function () {
                                Model[imgWH] = wh;
                            });
                        });
                    } else {
                        sameValue(prime);
                    }
                });
            }

            Model.cancel = function () {
                if (!$scope.isHarmony) {
                    $state.go('mysetting.modUserInfoCorp', {refresh: true}, {reload: true});
                } else {
                    AUI.BaseJSUtil.redirectUrl(location.href)
                }
            };
            Model.cancelSubmit = userAuth.cancelDeveloperUpdate;

            Model.corpNameKeyup = function () {
                var prime = primes.corpNamePrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.corpName != Model.userInfo.corpName) {
                    Model.isShowNameChangeDiv = true;
                    Model.isShowCorpNameChangeUnder = true;
                    differValue(prime);
                } else {
                    Model.isShowNameChangeDiv = false;
                    Model.isShowCorpNameChangeUnder = false;
                    sameValue(prime);
                }
            };

            Model.corpAddressKeyup = function () {
                checkPrime("corpAddress", "addressPrime");
            };

            Model.realNameEnKeyup = function () {
                checkPrime("realNameEn", "realNameEnPrime");
            };
            Model.contactNameKeyup = function () {
                checkPrime("contactName", "contactNamePrime");
            };
            Model.contactIdCardKeyup = function () {
                checkPrime("contactIdCard", "contactIdCardPrime");
            };

            Model.legalManKeyup = function () {
                checkPrime("legalMan", "legalManPrime");
            };
            Model.legalManCtfCodeKeyup = function () {
                checkPrime("legalManCtfCode", "legalManCtfCodePrime");
            };

            Model.contactEmailKeyup = function () {
                var prime = primes.contactEmailPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (Model.userInfo.contactEmail != oldUserInfo.contactEmail) {
                    differValue(prime);
                } else {
                    sameValue(prime);
                }
                Model.isEmailNeedCode = (!UserInfo.checkIsSameWithUPEmail(Model.userInfo.contactEmail, Model.userInfo.accountEmail)
                    && Model.userInfo.contactEmail != oldUserInfo.contactEmail)
            };

            Model.contactPhoneKeyup = function () {
                var prime = primes.contactPhonePrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.contactPhone != Model.userInfo.contactPhone) {
                    differValue(prime);
                } else {
                    sameValue(prime);
                }
                Model.isPhoneNeedCode = (!UserInfo.checkIsSameWithUPPhone(Model.userInfo.contactPhone, Model.userInfo.accountPhone)
                    && Model.userInfo.contactPhone != oldUserInfo.contactPhone)
            };

            Model.acceptEDMKeyup = function (acceptEDM) {
                if (Model.isAudting) return;
                Model.userInfo.acceptEDM = !acceptEDM;
                checkPrime("acceptEDM", "acceptEDM");
            };
            Model.corpBsLicIDKeyup = function () {
                checkPrime("corpBsLicID", "corpBsLicIDPrime");
            };

            Model.learnchannelsOtherKeyup = function () {
                var prime = primes.learnchannelsOther;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.learnchannelsOther) {
                    checkPrime("learnchannelsOther", "learnchannelsOther");
                } else {
                    if (Model.userInfo.learnchannelsOther) {
                        differValue(prime);
                    } else {
                        sameValue(prime);
                    }
                }
            };


            Model.reamrkKeyup = function () {
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.remark4userinfo) {
                    checkPrime("remark4userinfo", "remark4userinfo");
                } else {
                    if (Model.userInfo.remark4userinfo) {
                        differValue(primes.remark4userinfo);
                    } else {
                        sameValue(primes.remark4userinfo);
                    }
                }
            };

            function checkPrime(key, primeName) {
                var prime = primes[primeName];
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                (oldUserInfo[key] != Model.userInfo[key]) ? differValue(prime) : sameValue(prime);
            }


            Model.changeProvince = function (province) {
                regionService.setCity(province, function (data) {
                    Model.cities = data;
                    // 这里从原来下面的if挪出来，只要省份变更，城市就需要对应变更，否则会出现先变更成另外一个省份，然后还原，但是城市不变的情况。
                    Model.userInfo.city = Model.cities[0];
                    var prime = primes.provincePrime;
                    // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                    if (Model.userInfo.province && oldUserInfo.provinceName != Model.userInfo.province.key) {
                        Model.userInfo.provinceName = Model.userInfo.province.key;
                        Model.userInfo.cityName = Model.userInfo.city.key;
                        differValue(prime);
                    } else {
                        sameValue(prime);
                    }
                });
            };

            Model.changeCity = function () {
                var prime = primes.cityPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (Model.userInfo.city && oldUserInfo.cityName != Model.userInfo.city.key) {
                    Model.userInfo.cityName = Model.userInfo.city.key;
                    differValue(prime);
                } else {
                    sameValue(prime);
                }
            };

            Model.chooseThree2one = function ($event) {
                var checkbox = $event.target;
                if (checkbox.checked) {
                    Model.isThree2One = true;
                    Model.userInfo.corpLicense = '';
                    Model.userInfo.tax = '';
                    Model.userInfo.corpCode = '';
                    threeCentification2OneClickFun(true);
                    if (oldUserInfo.corpLicense != Model.userInfo.corpLicense) {
                        sameValue(primes.corpLicensePrime);
                    }

                    if (oldUserInfo.tax != Model.userInfo.tax) {
                        sameValue(primes.taxPrime);
                    }

                    if (oldUserInfo.corpCode != Model.userInfo.corpCode) {
                        sameValue(primes.corpCodePrime);
                    }

                    if (oldUserInfo.contactorImg10 != Model.userInfo.contactorImg10) {
                        differValue(primes.contactorImg10Prime);
                    }
                } else {
                    Model.isThree2One = false;
                    Model.userInfo.corpLicense = Model.userInfo.oldCorpLicense;
                    Model.userInfo.tax = Model.userInfo.oldTax;
                    Model.userInfo.corpCode = Model.userInfo.oldCorpCode;
                    threeCentification2OneClickFun(false);
                    if (oldUserInfo.corpLicense != Model.userInfo.corpLicense) {
                        differValue(primes.corpLicensePrime);
                    }

                    if (oldUserInfo.tax != Model.userInfo.tax) {
                        differValue(primes.taxPrime);
                    }

                    if (oldUserInfo.corpCode != Model.userInfo.corpCode) {
                        differValue(primes.corpCodePrime);
                    }
                    if (oldUserInfo.contactorImg10 != Model.userInfo.contactorImg10) {
                        sameValue(primes.contactorImg10Prime);
                    }
                }

                if (changeNum > 1) {
                    Model.greenSubmit();
                } else {
                    Model.graySubmit();
                }
            };

            Model.qqKeyup = function () {
                var prime = primes.qqPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.qq != Model.userInfo.qq) {
                    differValue(prime);
                } else {
                    sameValue(prime);
                }
            };

            // 输入控件值与原值不一样，处理changeNum及提交按钮的样式
            function differValue(prime) {
                changeNum = modUserInfoService.differValue(prime, changeNum);
                Model.greenSubmit();
            }

            // 输入控件值与原值一样，处理changeNum及提交按钮的样式
            function sameValue(prime) {
                changeNum = modUserInfoService.sameValue(prime, changeNum);
                // 如果计数已清空，则灰化提交按钮
                if (changeNum == 1) {
                    Model.graySubmit();
                }
            }


            // 提交按钮亮化
            function greenSubmit() {
                Model.submbIsGray = false;
                Model.doSubmit = doSummit;
            }

            // 提交按钮灰化
            function graySubmit() {
                Model.submbIsGray = true;
                Model.doSubmit = function () {
                };
            }

            function validateData() {
                if (Model.isEmailNeedCode && !Model.verifiedEmailSuccess) {
                    angular.element("[name='verifyEmailCode']").focus();
                    return false;
                }
                if (Model.isPhoneNeedCode && !Model.verifiedPhoneSuccess) {
                    angular.element("[name='verifyCode']").focus();
                    return false;
                }
                return true;
            }

            //修改提交
            function doSummit(isValid, corpUserForm) {
                if (changeNum > 1) {
                    if (!isValid || $scope.checkErrorPhone()) {
                        formValidateService.validateForm(corpUserForm);
                        validateData();
                        if(isValid && $scope.checkErrorPhone()){
                            angular.element("[name='contactPhone']").focus();
                        }
                    } else {
                        var params = getUpdateParam();
                        if (!validateData()) {
                            return;
                        }
                        //渠道不为为空
                        if (Model.channelsChecked.length == 0) {
                            Model.channelOtherCheck = true;
                            return;
                        } else {
                            Model.channelOtherCheck = false;
                        }

                        updateUserInfo(params);

                    }
                }
            }

            function updateUserInfo(params, callback) {
                Model.doSubmit = function () {
                };
                modUserInfoService.updateUserInfo(params).then(function (data) {
                    if (data && data.userID) {
                        if (!!callback) {
                            callback();
                        } else {
                            auiDialog.success('资料提交成功。', function () {
                                Model.cancel();
                                if (!$scope.isHarmony) {
                                    $scope.$emit("stateChangedEvent", true);
                                }
                            });
                        }
                    } else {
                        if (data && data.NSP_STATUS == 70009006) {
                            Model.errorPhone.push(Model.userInfo.contactPhone);
                        } else {
                            auiDialog.failSystemError($filter('auiErrorCode')(data && data.NSP_STATUS));
                        }
                        Model.resetVer = true;
                        Model.doSubmit = doSummit;
                    }
                });
            }

            // 组织更新接口调用的请求参数
            function getUpdateParam() {
                /*
                 * 组装developerInfo数据
                 */
                var devObj = {};
                if (oldUserInfo.contactName != Model.userInfo.contactName) {
                    devObj.contactName = Model.userInfo.contactName;
                }
                if (oldUserInfo.contactEmail != Model.userInfo.contactEmail) {
                    devObj.contactEmail = Model.userInfo.contactEmail;
                }
                if ($scope.isHarmony) {
                    devObj.acceptEDM = 2;
                } else {
                    devObj.acceptEDM = Model.userInfo.acceptEDM ? 1 : 2;
                }


                if (oldUserInfo.contactPhone != Model.userInfo.contactPhone) {
                    devObj.contactPhone = "0086" + Model.userInfo.contactPhone.replace("+", "00");
                }
                if (oldUserInfo.contactIdCard != Model.userInfo.contactIdCard) {
                    devObj.contactIdCard = Model.userInfo.contactIdCard;
                }
                if (oldUserInfo.qq != Model.userInfo.qq) {
                    devObj.contactQQ = Model.userInfo.qq;
                }
                if (oldUserInfo.realNameEn != Model.userInfo.realNameEn) {
                    // 隐藏数据提交
                    devObj.realNameEn = Model.userInfo.realNameEn;
                }
                if (Model.isSupportDevName) {
                    if (oldUserInfo.devName4Inner != Model.userInfo.devName4Inner) {
                        // 隐藏数据提交
                        devObj.devName4Inner = Model.userInfo.devName4Inner;
                    }

                    if (oldUserInfo.devNameEn4Inner != Model.userInfo.devNameEn4Inner) {
                        // 隐藏数据提交
                        devObj.devNameEn4Inner = Model.userInfo.devNameEn4Inner;
                    }

                }
                // 需要验证的手机号码提交验证码
                if (Model.isEmailNeedCode) {
                    devObj.emailAuthCode = Model.userInfo.verEmailCode;
                }
                // 需要验证的手机号码提交验证码
                if (Model.isPhoneNeedCode) {
                    devObj.smsAuthCode = Model.userInfo.verCode;
                }


                if (Model.needAppealAttach && Model.userInfo.appealAttach) {
                    devObj.appealAttach = Model.userInfo.appealAttach;
                }
                /*
                 * 组装corpDeveloper数据
                 */
                var corpObj = {};

                if (oldUserInfo.corpName != Model.userInfo.corpName) {
                    corpObj.corpName = Model.userInfo.corpName;
                }
                if (oldUserInfo.legalMan != Model.userInfo.legalMan) {//法人姓名
                    corpObj.legalMan = Model.userInfo.legalMan;
                }
                if (oldUserInfo.legalManCtfCode != Model.userInfo.legalManCtfCode) {//法人身份证号
                    corpObj.legalManCtfCode = Model.userInfo.legalManCtfCode;
                }
                if (oldUserInfo.corpBsLicID != Model.userInfo.corpBsLicID) {
                    corpObj.corpBsLicID = Model.userInfo.corpBsLicID;
                }

                if (oldUserInfo.corpAddress != Model.userInfo.corpAddress) {
                    corpObj.corpAddress = Model.userInfo.corpAddress;
                }
                // 最新省份和城市使用key的形式保存
                if (oldUserInfo.provinceName != Model.userInfo.province.key) {
                    corpObj.provinceName = Model.userInfo.province.key;
                    devObj.province = Model.userInfo.province.key;
                }
                if (oldUserInfo.cityName != Model.userInfo.city.key) {
                    corpObj.cityName = Model.userInfo.city.key;
                    devObj.city = Model.userInfo.city.key;
                }
                modUserInfoService.setLearnchannels(oldUserInfo, Model, devObj);

                if (oldUserInfo.remark4userinfo != Model.userInfo.remark4userinfo) {
                    devObj.remark4userinfo = Model.userInfo.remark4userinfo;
                }

                if (oldUserInfo.msgLang != Model.userInfo.msgLang) {
                    // 通知消息语种
                    devObj.msgLang = Model.userInfo.msgLang;
                }

                //图片


                //简化实名用户申请资料变更有三种情况
                //1、名称未变化  contactorImg1 不空 把1，2，3,4,5,10置空
                //2、名称未变化  contactorImg1 空
                //3、名称变化   contactorImg1 不空
                //4、名称变化   contactorImg1 空
                if (oldUserInfo.userType == 2 && oldUserInfo.verifyRealType == 2) {
                    if (!Model.isRadioSelected && oldUserInfo.contactorImg1) {
                        //简化实名用户
                        if (Model.userInfo.contactorImg1 && oldUserInfo.contactorImg1 != Model.userInfo.contactorImg1) {
                            corpObj.attachment7 = Model.userInfo.contactorImg1;
                        }
                        if (Model.userInfo.contactorImg2 && oldUserInfo.contactorImg2 != Model.userInfo.contactorImg2) {
                            corpObj.attachment8 = Model.userInfo.contactorImg2;
                        }
                        if (Model.userInfo.contactorImg3 && oldUserInfo.contactorImg3 != Model.userInfo.contactorImg3) {
                            corpObj.attachment9 = Model.userInfo.contactorImg3;
                        }
                        if (oldUserInfo.corpLicense) corpObj.attachment1 = "";
                        if (oldUserInfo.tax) corpObj.attachment2 = "";
                        if (oldUserInfo.corpCode) corpObj.attachment3 = "";
                        if (oldUserInfo.corpEntityPicFile) corpObj.attachment4 = "";
                        if (oldUserInfo.corpEntityPicFile1) corpObj.attachment5 = "";
                        if (oldUserInfo.contactorImg10) corpObj.attachment10 = "";
                    } else if (Model.isRadioSelected && oldUserInfo.contactorImg1) {
                        if (Model.userInfo.contactorImg10 && oldUserInfo.contactorImg10 != Model.userInfo.contactorImg10 && Model.isThree2One) {
                            corpObj.attachment10 = Model.userInfo.contactorImg10;
                        }
                        if (Model.userInfo.corpLicense && oldUserInfo.corpLicense != Model.userInfo.corpLicense && Model.isThree2One) {
                            corpObj.attachment1 = Model.userInfo.corpLicense;
                        }
                        if (!Model.userInfo.corpLicense && Model.isThree2One) {
                            corpObj.attachment1 = '';
                        }
                        if (!Model.userInfo.tax && Model.isThree2One) {
                            corpObj.attachment2 = '';
                        }
                        if (Model.userInfo.tax && oldUserInfo.tax != Model.userInfo.tax && Model.isThree2One) {
                            corpObj.attachment2 = Model.userInfo.tax;
                        }
                        if (!Model.userInfo.corpCode && Model.isThree2One) {
                            corpObj.attachment3 = '';
                        }
                        if (Model.userInfo.corpCode && oldUserInfo.corpCode != Model.userInfo.corpCode && Model.isThree2One) {
                            corpObj.attachment3 = Model.userInfo.corpCode;
                        }
                        if (Model.userInfo.corpEntityPicFile && oldUserInfo.corpEntityPicFile != Model.userInfo.corpEntityPicFile) {
                            corpObj.attachment4 = Model.userInfo.corpEntityPicFile;
                        }
                        if (Model.userInfo.corpEntityPicFile1 && oldUserInfo.corpEntityPicFile1 != Model.userInfo.corpEntityPicFile1) {
                            corpObj.attachment5 = Model.userInfo.corpEntityPicFile1;
                        }

                        if (oldUserInfo.contactorImg1) {
                            corpObj.attachment7 = "";
                        }
                        if (oldUserInfo.contactorImg2) {
                            corpObj.attachment8 = "";
                        }
                        if (oldUserInfo.contactorImg3) {
                            corpObj.attachment9 = "";
                        }

                    }
                } else {
                    if (Model.userInfo.contactorImg10 && oldUserInfo.contactorImg10 != Model.userInfo.contactorImg10 && Model.isThree2One) {
                        corpObj.attachment10 = Model.userInfo.contactorImg10;
                    }
                    if (Model.userInfo.corpLicense && oldUserInfo.corpLicense != Model.userInfo.corpLicense && Model.isThree2One) {
                        corpObj.attachment1 = Model.userInfo.corpLicense;
                    }
                    if (!Model.userInfo.corpLicense && Model.isThree2One) {
                        corpObj.attachment1 = '';
                    }
                    if (Model.userInfo.tax && oldUserInfo.tax != Model.userInfo.tax && Model.isThree2One) {
                        corpObj.attachment2 = Model.userInfo.tax;
                    }
                    if (!Model.userInfo.tax && Model.isThree2One) {
                        corpObj.attachment2 = '';
                    }
                    if (Model.userInfo.corpCode && oldUserInfo.corpCode != Model.userInfo.corpCode && Model.isThree2One) {
                        corpObj.attachment3 = Model.userInfo.corpCode;
                    }
                    if (!Model.userInfo.corpCode && Model.isThree2One) {
                        corpObj.attachment3 = '';
                    }
                    if (Model.userInfo.corpEntityPicFile && oldUserInfo.corpEntityPicFile != Model.userInfo.corpEntityPicFile) {
                        corpObj.attachment4 = Model.userInfo.corpEntityPicFile;
                    }
                    if (Model.userInfo.corpEntityPicFile1 && oldUserInfo.corpEntityPicFile1 != Model.userInfo.corpEntityPicFile1) {
                        corpObj.attachment5 = Model.userInfo.corpEntityPicFile1;
                    }

                }

                if (!Model.isCorpattionRz) {
                    if (Model.isThree2One) {
                        corpObj.isThreeInOne = 1;
                    } else {
                        corpObj.isThreeInOne = 0;
                    }
                } else {
                    //开通商户签完花瓣协议和隐私协议之后补充证件照的场景
                    if (Model.isShowLegalPic) {
                        corpObj.isThreeInOne = 1;
                    }
                }


                // 组装最终的请求参数对象
                var params = {};
                if (!AUI.BaseJSUtil.isEmptyArray(devObj)) {
                    params.developerInfo = devObj;
                }
                if (!AUI.BaseJSUtil.isEmptyArray(corpObj)) {
                    params.corpDeveloper = corpObj;
                }
                if ($scope.isHarmony) {
                    params.channelType = (Model.hmChannel && Model.hmChannel !== '') ? Model.hmChannel : 8;
                }

                return params;
            }


            function setUserInfo() {
                UserInfo.getUserInfo().then(function (user) {
                    //开关开后优化吧  暂时查询1000
                    auiAgreementHelper.queryAgreements([systemParaConf.petalsAgreements.tremPdfConfType, systemParaConf.petalsAgreements.ServicePdfConfType]).then(function (res) {
                        if (user.verifyBankState == 2 && res.signInfoList && res.signInfoList[0] && res.signInfoList[1] && (res.signInfoList[0].signStatus == 1 || res.signInfoList[0].signStatus == 2) && (res.signInfoList[1].signStatus == 1 || res.signInfoList[1].signStatus == 2)) {
                            if (user.verifyType == 3) {
                                Model.isShowLegalPic = true;
                            }
                            if (!user.corpBsLicID) {
                                Model.isShowCorpBsLicID = true;
                            }
                        }
                        //开通境内银行并签署了花瓣协议跳到开发者信息默认为三证合一用户
                        if (Model.isShowLegalPic && !user.corpLicense && !user.tax && !user.corpCode && !Model.isAudting) {
                            user.isThreeInOne = 1;
                        }
                        Model.userInfo = angular.copy(user);
                        Model.oldDevName4Inner = angular.copy(Model.userInfo.devName4Inner);//处理展示逻辑
                        Model.oldDevNameEn4Inner = angular.copy(Model.userInfo.devNameEn4Inner);//处理展示逻辑
                        Model.oldLegalMan = angular.copy(Model.userInfo.legalMan);//处理展示逻辑
                        Model.oldLegalManCtfCode = angular.copy(Model.userInfo.legalManCtfCode);//处理展示逻辑
                        Model.isCorpFaceRz = Model.userInfo.corpEntityPicFile == '';
                        Model.userInfo.corpBsLicIDFirst = angular.copy(Model.userInfo.corpBsLicID);
                        if (Model.userInfo.verifyType == 3 && Model.userInfo.verifyRealType == 4) {
                            Model.hwCloudIdShow = true
                        }
                        if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                            if (Model.userInfo.userType == 1) {
                                $state.go('mysetting.modUserInfoPer', {reload: true});
                                return;
                            }
                        } else {
                            $state.go('mysetting.memberDetail', {reload: true});
                            return;
                        }

                        userInfoToString = angular.toJson(angular.copy(Model.userInfo));
                        modUserInfoService.saveOldUserInfo(oldUserInfo, Model.userInfo);
                        //修改变更驳回
                        if (user.updateRealState == 3) {
                            if (Model.userInfo.approveOpinion == "102") {
                                Model.isTipShow = true;
                                Model.firstmessTip = "【系统消息】您提交的更名申请，由于银行信息审核不通过被驳回,请参照商户服务页面的审核意见修改后提交重新提交更名申请。";
                            }
                        }
                        //设置是否展示关联关系问卷调查链接
                        if (!$scope.isHarmony && user.userType == 2 && user.verifyRealState == 2 && (user.commerceCertifyStatus == 2 || user.payCertifyStatus == 2)) {
                            Model.isShowQuetionnare = true;
                        }
                        Model.userInfo.userTypeDesc = mainCons.modUserinfoConstant.corUserType.commonCertification;
                        //企业用户简化认证
                        if (user.userType == 2 && user.verifyRealType == 1) {
                            Model.userInfo.userTypeDesc = mainCons.modUserinfoConstant.corUserType.simpleCertification;
                            Model.isShowSimplifyApproval = false;  //隐藏三张，显示五张
                            Model.isShowNormalApproval = true;
                            Model.isShowNormalApproval3to1 = true;
                            Model.userInfo.corpLicense = '';
                            Model.userInfo.tax = '';
                            Model.userInfo.corpCode = '';
                            modUserInfoService.drawImage(Model, "contactorImg1", "contactorImg1WH", $scope);
                            modUserInfoService.drawImage(Model, "contactorImg2", "contactorImg2WH", $scope);
                            modUserInfoService.drawImage(Model, "contactorImg3", "contactorImg3WH", $scope);
                            if (user.isThreeInOne == 1) {
                                Model.showThree2OneBox = false;
                                Model.isShowNormalApproval3to1 = true;
                                Model.isThree2One = true;
                            } else if (user.isThreeInOne == 0) {
                                Model.isThree2One = false;
                                Model.isShowNormalApproval3to1 = false;
                                Model.showThree2OneBox = true;
                                threeCentification2OneClickFun(false);
                            }

                        }
                        //企业用户正常实名认证,或简化转正常用户
                        else if (user.userType == 2 && (user.verifyRealType == 0 || user.verifyRealType == 4 || (user.verifyRealType == 2 && !user.contactorImg1))) {
                            Model.isShowSimplifyApproval = false;
                            Model.isShowNormalApproval = true;

                            if (user.isThreeInOne == 0) {
                                Model.userInfo.oldCorpLicense = user.corpLicense;
                                Model.userInfo.oldTax = user.tax;
                                Model.userInfo.oldCorpCode = user.corpCode;
                                Model.isThree2One = false;
                                Model.isShowNormalApproval3to1 = false;
                                Model.showThree2OneBox = true;
                                threeCentification2OneClickFun(false);
                            }
                            if (user.isThreeInOne == 1) {
                                Model.showThree2OneBox = false;
                                Model.isShowNormalApproval3to1 = true;
                                Model.isThree2One = true;
                            }
                            isThree = user.isThreeInOne;
                        }
                        //企业用户正常实名认证,或简化转正常用户
                        else if (user.userType == 2 && user.verifyRealType == 2) {
                            Model.isShowSimplifyApproval = true;
                            Model.isShowNormalApproval = false;
                            modUserInfoService.drawImage(Model, "contactorImg1", "contactorImg1WH", $scope);
                            modUserInfoService.drawImage(Model, "contactorImg2", "contactorImg2WH", $scope);
                            modUserInfoService.drawImage(Model, "contactorImg3", "contactorImg3WH", $scope);
                        }
                        //个人转企业用户
                        else {
                            Model.isShowSimplifyApproval = true;
                            Model.isShowNormalApproval = false;
                        }


                        // 获取省份和城市，现在统一通过idata来获取
                        Model.userInfo.province = {
                            'key': Model.userInfo.provinceName,
                            'value': regionService.getProvinceFromList(Model.userInfo.provinceName, Model.provinces)
                        };
                        regionService.setCity(Model.userInfo.provinceName, function (data) {
                            Model.cities = data;
                            Model.userInfo.city = {
                                'key': Model.userInfo.cityName,
                                'value': regionService.getCityFromList(Model.userInfo.cityName, Model.cities)
                            };
                        });

                        //获取获知渠道
                        if (Model.userInfo.learnchannels) {
                            Model.channelsChecked = Model.userInfo.learnchannels.split(';');
                            for (var ch = 0; ch < Model.channelsChecked.length; ch++) {
                                Model.channelsChecked[ch] = parseInt(Model.channelsChecked[ch]);
                            }
                        }
                        //说明是审核中
                        if ((user.verifyRealState == 1) || (user.updateRealState == 1) || user.isChangeRealName == 1) {
                            //说明是更名中
                            if (user.isChangeRealName == 1) {
                                Model.isRadioSelected = true;
                                Model.isShowNameChangeDiv = true;
                            } else {
                                Model.isShowNameChangeDiv = false;
                            }
                            AUI.HTMLUtil.drawImage(180, 120, Model.userInfo.corpNameChange, function (wh) {
                                $scope.$apply(function () {
                                    Model.corpNameChangeWH = wh;
                                });
                            });
                            if (user.contactorImg11 && Model.isRadioSelected) {
                                AUI.HTMLUtil.drawImage(180, 120, Model.userInfo.contactorImg11, function (wh) {
                                    $scope.$apply(function () {
                                        Model.contactorImg11WH = wh;
                                    });
                                });
                                Model.isShowCorpNameChangeUnder = true;
                            } else {
                                Model.isShowCorpNameChangeUnder = false;
                            }
                            Model.isShowChaicon = false;
                            setReadOnly();
                        } else {
                            Model.isShowNameChangeDiv = false;
                            Model.isShowChaicon = true;
                            Model.userInfo.contactorImg11 = '';
                            Model.userInfo.corpNameChange = '';
                        }

                        setDrawImage('contactorImg10', 'contactorImg10WH');
                        setDrawImage('corpLicense', 'corpLicenseWH');
                        setDrawImage('tax', 'taxWH');
                        setDrawImage('corpCode', 'corpCodeWH');
                        setDrawImage('corpEntityPicFile', 'corpEntityPicFileWH');
                        setDrawImage('corpEntityPicFile1', 'corpEntityPicFile1WH');

                        //实名变更增加的选项配置 start
                        Model.updateRealState = user.updateRealState;
                        Model.payCertifyStatus = user.payCertifyStatus;
                        Model.verifyRealState = user.verifyRealState;
                        Model.alChgRealName = user.alChgRealName;
                        Model.isChangeRealName = user.isChangeRealName;
                        modBussService.getMerchantInfo(function (bankInfos) {
                            //有境内银行帐号,且境内银行帐号和跨境银行帐号 在审核中的情况，则不展示更名按钮
                            if ((bankInfos.bankInfoCN && (bankInfos.bankInfoCN.verifyBankState === 1 || bankInfos.bankInfoCN.updateBankState === 1)) ||
                                (bankInfos.bankInfoEN && (bankInfos.bankInfoEN.verifyBankState === 1 || bankInfos.bankInfoEN.updateBankState === 1))) {
                                Model.isShowForBankState = false;
                            } else {
                                Model.isShowForBankState = true;
                            }
                        });
                        //实名变更增加的选项配置 end
                        if (!Model.userInfo.corpLicense && !Model.userInfo.contactorImg1 && !Model.userInfo.contactorImg10 && !Model.userInfo.corpEntityPicFile) {
                            if (Model.userInfo.verifyType == 3) {
                                Model.isCorpattionRz = true;
                            } else {
                                Model.isCorpattionRz = false;
                            }

                        } else {
                            Model.isCorpattionRz = false;
                        }

                        $scope.corpUserForm && $scope.corpUserForm.realNameEn && $scope.corpUserForm.realNameEn.$setDirty();

                        // 选择的语种
                        Model.selectedMsgLang = langService.getLangItemByLang(Model.userInfo.msgLang);

                        //是否展示needAppealAttach 申诉附件
                        getExtAttr('needAppealAttach').then(function (flag) {
                            if (flag == 1) {
                                Model.needAppealAttach = true;
                            }
                        });
                        commonUtils.picExtend("imges1", "imges2");
                    })

                });
            }


            function getExtAttr(name) {
                var defer = $q.defer();
                modUserInfoService.getExtAttr(name).then(function (flag) {
                    defer.resolve(flag);
                });
                return defer.promise;
            }

            function setDrawImage(type, typewh) {
                AUI.HTMLUtil.drawImage(180, 120, Model.userInfo[type], function (wh) {
                    $scope.$apply(function () {
                        Model[typewh] = wh;
                    });
                });
            }


            //选择取消三合一选项控制样式
            function threeCentification2OneClickFun(isChosen) {
                Model.isShowNormalApproval3to1 = isChosen;
            }


            // 设置页面只读
            function setReadOnly() {
                Model.isAudting = true;
                Model.isRadioDisable = true;
                Model.graySubmit();
            }

            Model.toQuestionnaire = function () {
                $state.go('questionnaire', {reload: true});
            };

            Model.toModCloudAcademy = function () {
                $state.go('modCloudCademyinfo', {reload: true});
            };

            // 设置通知消息语种
            Model.changeMsgLang = function (selected) {
                Model.userInfo.msgLang = selected.key;
                // 获取质数
                var prime = primes.msgLangPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                (Model.userInfo.msgLang && oldUserInfo.msgLang != Model.userInfo.msgLang) ? differValue(prime, changeNum) : sameValue(prime, changeNum);

            };

            function validateIDNumber() {
                return {
                    test: function (value) {
                        if (value) {
                            var msg = /^[a-zA-Z0-9]{1,18}$/
                            return value.match(msg)
                        } else {
                            return true
                        }
                    }
                };
            }

            //校验身份号码格式是否正确
            Model.validateIDNumber = validateIDNumber();


        }]);
});

